import Work1UIX from "../../assets/uix/UIX1.webp";
import Work2UIX from "../../assets/uix/UIX2.webp";
import Work3UIX from "../../assets/uix/UIX3.webp";
import Work4UIX from "../../assets/uix/UIX4.webp";
import Work1Web from "../../assets/website/web3.webp";
import Work3Web from "../../assets/website/web5.webp";
import Work4Web from "../../assets/website/web6.webp";
import Work5Web from "../../assets/website/web7.webp";
import Work6Others from "../../assets/others/other5.webp";
import Work1Certificate from "../../assets/certificate/sertifikat4.webp";
import Work2Certificate from "../../assets/certificate/sertifikat5.webp";
import Work3Certificate from "../../assets/certificate/sertifikat6.webp";
import Work4Certificate from "../../assets/certificate/sertifikat7.webp";
import Work5Certificate from "../../assets/certificate/sertifikat8.webp";
import Work6Certificate from "../../assets/certificate/sertifikat1.webp";
// import Work7Certificate from "../../assets/certificate/sertifikat2.webp";
import Work8Certificate from "../../assets/certificate/sertifikat9.webp";
// import Work9Certificate from "../../assets/certificate/sertifikat10.webp";

export const projectsData = [
  {
    id: 1,
    image: Work2UIX,
    title: "UI/UX PT Rumah Mesin Kreatif",
    category: "ui/ux",
    link: "https://www.behance.net/gallery/200107291/Heavy-Equipment-Company-UIUX-Design-Website"
  },
  {
    id: 2,
    image: Work3UIX,
    title: "UI/UX AFC ASIAN CUP APP",
    category: "ui/ux",
    link: "https://www.behance.net/gallery/200099901/AFC-Asian-Cup-App-UIUX-Design-Portfolio",
    role: "Lead UI/UX Designer",
    client: "AFC Asian Cup (Concept Portfolio)",
    duration: "Jan - Feb 2024",
    details: {
      overview: "AFC Asian Cup App adalah platform digital mobile terintegrasi yang dirancang khusus untuk memfasilitasi kebutuhan para penggemar sepak bola selama turnamen bergengsi Piala Asia AFC berlangsung. Aplikasi ini mengintegrasikan seluruh pengalaman turnamen—mulai dari berita terbaru, pembaruan skor real-time, statistik mendalam, hub sosial antarpenggemar (Fan Zone), hingga sistem pembelian tiket digital (e-ticketing) yang mulus dan panduan navigasi stadion terintegrasi.",
      problemStatement: "Meskipun antusiasme turnamen sangat tinggi, penggemar sering kali kesulitan memperoleh informasi terkini secara efisien dan cepat karena data yang tersebar di berbagai platform. Beberapa masalah utama yang diidentifikasi meliputi:",
      problems: [
        {
          title: "Informasi Terfragmentasi",
          desc: "Penggemar harus berpindah-pindah aplikasi atau situs web untuk melihat jadwal, klasemen, statistik, dan berita terkini."
        },
        {
          title: "Sistem Pembelian Tiket Rumit",
          desc: "Pembelian tiket fisik atau digital sering kali tidak praktis, memakan waktu lama, dan rentan terhadap antrean panjang atau kendala teknis."
        },
        {
          title: "Kurangnya Panduan Hari Pertandingan",
          desc: "Penggemar yang datang langsung ke stadion sering kali kesulitan menemukan pintu masuk, kursi, atau fasilitas umum karena minimnya panduan navigasi interaktif."
        },
        {
          title: "Keterlibatan Penggemar yang Rendah",
          desc: "Platform resmi yang ada saat ini bersifat satu arah, kurang interaktif, dan tidak menyediakan ruang bagi fans untuk berinteraksi, berdiskusi, atau berpartisipasi dalam mini-games."
        }
      ],
      personas: [
        {
          name: "David Miller",
          age: 28,
          role: "Passionate Fan / Suporter Fanatik",
          bio: "David adalah penggemar sepak bola yang tidak pernah melewatkan pertandingan tim nasionalnya. Ia selalu ingin tahu statistik real-time, susunan pemain, dan berita terbaru sebelum dan saat laga berlangsung.",
          goals: [
            "Memperoleh statistik & update pertandingan instan",
            "Membeli tiket pertandingan dengan cepat tanpa antrean"
          ],
          pains: [
            "Data internet lambat saat di stadion yang ramai",
            "Aplikasi official sebelumnya sangat lambat & membingungkan"
          ],
          avatar: "bx bx-user-voice"
        },
        {
          name: "Sarah Tan",
          age: 34,
          role: "Family Spectator / Penonton Keluarga",
          bio: "Sarah ingin mengajak anak-anaknya menonton langsung ke stadion untuk pertama kalinya. Ia menginginkan pengalaman yang aman, nyaman, dan terorganisir dengan baik.",
          goals: [
            "Mendapatkan tiket berdekatan untuk seluruh keluarga",
            "Menemukan gerbang masuk, kursi, & fasilitas toilet dengan mudah"
          ],
          pains: [
            "Kesulitan navigasi di sekitar kawasan stadion yang padat suporter",
            "Khawatir kehabisan tiket atau proses refund yang berbelit-belit"
          ],
          avatar: "bx bx-smile"
        }
      ],
      solutions: "Merancang ulang aplikasi AFC Asian Cup dengan pendekatan User-Centered Design (UCD) yang menempatkan kebutuhan suporter sebagai prioritas utama. Solusi yang dirancang berfokus pada integrasi informasi, kemudahan transaksi tiket secara digital, serta peningkatan keterlibatan (engagement) penggemar melalui gamifikasi dan fitur komunitas.",
      features: [
        {
          title: "Match Center & Real-time Live Scores",
          desc: "Menyediakan pembaruan skor langsung secara instan, statistik pertandingan yang mendalam, susunan pemain, serta timeline visual jalannya pertandingan secara real-time.",
          icon: "bx bx-football"
        },
        {
          title: "Seamless Digital E-Ticketing",
          desc: "Pembelian, penyimpanan, dan pemindaian tiket terintegrasi dalam satu aplikasi dengan kode QR unik yang dapat diakses secara luring (offline).",
          icon: "bx bx-qr"
        },
        {
          title: "Fan Zone & Interactive Games",
          desc: "Ruang komunitas di mana penggemar dapat berpartisipasi dalam kuis, voting Man of the Match, game prediksi skor, dan papan peringkat interaktif.",
          icon: "bx bx-game"
        },
        {
          title: "Stadion & Matchday Guide",
          desc: "Panduan berbasis GPS interaktif yang membantu penonton menemukan rute terbaik menuju stadion, gerbang masuk yang tepat, tempat duduk, hingga toilet terdekat.",
          icon: "bx bx-map-pin"
        },
        {
          title: "Personalization Dashboard",
          desc: "Pengalaman yang disesuaikan di mana pengguna dapat memilih tim favorit mereka untuk menerima notifikasi instan, berita khusus, dan tema visual yang relevan.",
          icon: "bx bx-user"
        }
      ],
      userFlow: [
        { step: "1", label: "Pilih Menu Tiket", desc: "Pengguna membuka aplikasi dan menekan menu 'Tickets' pada bilah navigasi utama." },
        { step: "2", label: "Pilih Pertandingan", desc: "Melihat daftar pertandingan yang tersedia dan memilih laga yang ingin ditonton." },
        { step: "3", label: "Pilih Kategori & Kursi", desc: "Memilih kategori tribun (VIP, Kategori 1/2) serta memilih nomor kursi yang tersedia secara interaktif." },
        { step: "4", label: "Isi Data & Pembayaran", desc: "Memasukkan data pemesan secara otomatis dan menyelesaikan transaksi dengan e-wallet atau transfer bank." },
        { step: "5", label: "E-Ticket Diterbitkan", desc: "Tiket dengan kode QR dinamis diterbitkan dan otomatis disimpan di menu 'My Tickets'." }
      ],
      designSystem: {
        typography: {
          fontFamily: "Outfit",
          description: "Outfit dipilih sebagai font utama karena memiliki karakteristik modern, geometris, bersih, dan sangat mudah dibaca baik di layar perangkat mobile berukuran kecil maupun sebagai judul besar yang dinamis."
        },
        colors: [
          { name: "Deep Navy Blue", hex: "#0B1E36", type: "Primary", desc: "Mewakili profesionalisme, integritas olahraga, dan memberikan kesan elegan premium pada antarmuka." },
          { name: "Vibrant Crimson Red", hex: "#E31B23", type: "Secondary", desc: "Membangkitkan energi, semangat kompetitif yang membara, dan menjadi warna aksen utama." },
          { name: "Glory Golden Yellow", hex: "#F2A900", type: "Accent", desc: "Melambangkan kemenangan, prestasi tertinggi, dan kejayaan kejuaraan sepak bola Asia." },
          { name: "Neutral Clean White", hex: "#FFFFFF", type: "Neutral Base", desc: "Digunakan sebagai warna dasar latar belakang halaman untuk menjaga keterbacaan tinggi dan kebersihan visual." },
          { name: "Soft Ice Gray", hex: "#F4F6F9", type: "Neutral Surface", desc: "Digunakan sebagai warna latar belakang kartu (card), kontainer informasi, dan pemisah konten." }
        ]
      },
      tools: ["Figma", "Adobe Photoshop", "Adobe Illustrator"]
    }
  },
  {
    id: 3,
    image: Work1Web,
    title: "Movies Information Website",
    category: "website",
    link: "https://kyy-movies.netlify.app/"
  },
  {
    id: 4,
    image: Work3Web,
    title: "SMAN Science Six Class Website",
    category: "website",
    link: "https://sman1talun.sch.id/sciesixx/"
  },
  {
    id: 5,
    image: Work4Web,
    title: "PT Rumah Mesin Kreatif Website",
    category: "website",
    link: "https://rumek.netlify.app"
  },
  {
    id: 6,
    image: Work1Certificate,
    title: "Belajar Dasar Pemrograman Web",
    category: "certificate",
    link: "https://www.dicoding.com/certificates/QLZ9775KEP5D"
  },
  {
    id: 7,
    image: Work2Certificate,
    title: "Python Fundamental",
    category: "certificate",
    link: "https://www.dicoding.com/certificates/QLZ97GY67P5D"
  },
  {
    id: 8,
    image: Work3Certificate,
    title: "AI Fundamental",
    category: "certificate",
    link: "https://www.dicoding.com/certificates/MEPJNN444X3V"
  },
  {
    id: 9,
    image: Work4Certificate,
    title: "Data Visualization Fundamental",
    category: "certificate",
    link: "https://www.dicoding.com/certificates/JLX17J3Q5X72"
  },
  {
    id: 10,
    image: Work5Certificate,
    title: "SQL Fundamental",
    category: "certificate",
    link: "https://www.dicoding.com/certificates/JLX17J7EGX72"
  },
  {
    id: 11,
    image: Work6Certificate,
    title: "Website Development",
    category: "certificate"
  },
  // {
  //   id: 20,
  //   image: Work7Certificate,
  //   title: "Python Course",
  //   category: "certificate"
  // },
  {
    id: 12,
    image: Work8Certificate,
    title: "Javascript Course",
    category: "certificate"
  },
  // {
  //   id: 22,
  //   image: Work9Certificate,
  //   title: "LKMM PRA-TD SERTIF PESERTA",
  //   category: "certificate"
  // },
  {
    id: 13,
    image: Work5Web,
    title: "PMR Event Website 2025",
    category: "website",
    link: "https://kyy-bm-smanta.netlify.app"
  },
  {
    id: 14,
    image: Work6Others,
    title: "Rebranding Guidelines Twitter",
    category: "branding",
    link: "https://www.behance.net/gallery/227348313/Guidelines-Rebranding-Twitter"
  },
  {
    id: 15,
    image: Work4UIX,
    title: "UI/UX Gerak Aktifin Website",
    category: "ui/ux",
    link: "https://www.figma.com/proto/FF0gjm1h29zyrm23m6f6Y4/Lomba-Proposal-UI-UX-Gerakin?node-id=1-47&t=uZQxNVbeKROjcg6Q-1",
    role: "Lead UI/UX Designer",
    client: "Program Pendanaan ICASVI 2025",
    duration: "Mei - Juli 2025",
    details: {
      overview: "Gerak Aktifin (GERAKIN) adalah platform digital berbasis website yang dirancang untuk merespons tingginya perilaku hidup tidak aktif (sedentary lifestyle) di kalangan remaja dan dewasa muda. Melalui pendekatan inovatif yang menggabungkan pelacakan aktivitas fisik, gamifikasi berbasis tantangan seru, reward motivasional, serta fitur komunitas interaktif, GERAKIN bertujuan untuk mengubah kebiasaan kurang gerak menjadi gaya hidup aktif dan sehat yang berkelanjutan.",
      problemStatement: "Kemajuan teknologi digital membuat masyarakat semakin dimanjakan oleh kemudahan, yang berdampak pada berkurangnya aktivitas fisik harian. Beberapa tantangan utama yang ingin diselesaikan oleh GERAKIN meliputi:",
      problems: [
        {
          title: "Tingginya Gaya Hidup Sedentary",
          desc: "Sebagian besar mahasiswa dan pekerja kantoran menghabiskan waktu lebih dari 8-10 jam sehari duduk di depan layar komputer tanpa peregangan atau gerakan fisik."
        },
        {
          title: "Kurangnya Motivasi Konsisten",
          desc: "Olahraga sering kali dianggap membosankan dan melelahkan, sehingga banyak orang menyerah atau gagal membangun rutinitas kebugaran di minggu-minggu awal."
        },
        {
          title: "Ketiadaan Rekan & Komunitas",
          desc: "Seseorang lebih cenderung konsisten berolahraga jika dilakukan bersama. Namun, mencari partner olahraga atau komunitas lokal yang sesuai cukup sulit."
        },
        {
          title: "Kurangnya Apresiasi Aktivitas",
          desc: "Tidak adanya bentuk penghargaan atau feedback positif langsung atas usaha fisik yang telah dilakukan pengguna membuat motivasi jangka panjang cepat menurun."
        }
      ],
      personas: [
        {
          name: "Rafi Gunawan",
          age: 20,
          role: "Mahasiswa & Gamer",
          bio: "Rafi menghabiskan waktu seharian di kamar untuk kuliah online dan bermain game. Ia mulai merasakan nyeri punggung dan ingin aktif bergerak, tetapi merasa olahraga terlalu kaku dan membosankan tanpa adanya keseruan digital.",
          goals: [
            "Menemukan tantangan fisik yang seru dan ringan",
            "Membangun kebiasaan bergerak tanpa merasa terbebani"
          ],
          pains: [
            "Sangat mudah bosan jika olahraga terasa monoton",
            "Tidak ada teman yang bisa diajak berkompetisi secara menyenangkan"
          ],
          avatar: "bx bx-user"
        },
        {
          name: "Dinda Lestari",
          age: 25,
          role: "Web Developer / Pekerja WFH",
          bio: "Dinda bekerja dari rumah dan jarang keluar rumah. Ia ingin meningkatkan kebugaran tubuhnya secara teratur tetapi kesulitan mencari waktu, melacak progres, dan membutuhkan dorongan sosial untuk tetap konsisten.",
          goals: [
            "Bergabung dengan komunitas lari atau workout lokal",
            "Mendapatkan apresiasi atau insentif kecil dari aktivitas olahraganya"
          ],
          pains: [
            "Kesulitan membagi waktu dan mengatur target harian yang realistis",
            "Minimnya info komunitas olahraga terdekat di areanya"
          ],
          avatar: "bx bx-happy-beaming"
        }
      ],
      solutions: "Menghadirkan GERAKIN sebagai platform website kebugaran interaktif berbasis gamifikasi. Solusi ini memadukan tantangan gerak harian, sistem poin keaktifan (FitPoints) yang dapat dikonversi menjadi reward, serta ruang komunitas interaktif untuk menciptakan ekosistem kebugaran yang menyenangkan dan memotivasi pengguna untuk terus aktif bergerak setiap hari.",
      features: [
        {
          title: "Daily Movement Challenges",
          desc: "Tantangan fisik bervariasi setiap hari (seperti jalan kaki 5000 langkah, workout 10 menit) yang didesain menyenangkan untuk pengguna pemula.",
          icon: "bx bx-run"
        },
        {
          title: "Gamified Fitness & FitPoints Store",
          desc: "Sistem poin keaktifan yang didapat setelah menyelesaikan tantangan. Poin ini dapat ditukar dengan voucher diskon makanan sehat, merchandise, atau tiket event olahraga.",
          icon: "bx bx-gift"
        },
        {
          title: "Community Hub (Teman Gerak)",
          desc: "Memungkinkan pengguna membuat atau bergabung dengan komunitas olahraga terdekat, berdiskusi, serta mengadakan sesi workout bersama.",
          icon: "bx bx-group"
        },
        {
          title: "Personalized Activity Dashboard",
          desc: "Visualisasi riwayat aktivitas fisik, jumlah langkah kaki, durasi bergerak, dan perkiraan kalori yang dibakar yang disajikan dalam diagram interaktif.",
          icon: "bx bx-bar-chart-alt-2"
        },
        {
          title: "Leaderboard & Badges Achievement",
          desc: "Sistem peringkat persahabatan antar teman dan lencana prestasi (badges) untuk mengapresiasi setiap pencapaian kebugaran baru pengguna.",
          icon: "bx bx-trophy"
        }
      ],
      userFlow: [
        { step: "1", label: "Registrasi & Set Goal", desc: "Pengguna membuat akun dan menentukan target kebugaran harian (misal: durasi bergerak atau kalori)." },
        { step: "2", label: "Pilih & Jalankan Tantangan", desc: "Melihat daftar tantangan aktif di dashboard dan mulai melakukan aktivitas fisik yang dipilih." },
        { step: "3", label: "Catat Progres Aktivitas", desc: "Merekam aktivitas fisik melalui input manual atau menghubungkan tracker eksternal untuk verifikasi otomatis." },
        { step: "4", label: "Dapatkan FitPoints & Lencana", desc: "Tantangan yang berhasil diverifikasi akan memberikan poin kebugaran langsung dan lencana pencapaian." },
        { step: "5", label: "Tukarkan Reward Kebugaran", desc: "Pengguna menukarkan poin yang terkumpul dengan hadiah menarik di halaman Rewards Store." }
      ],
      designSystem: {
        typography: {
          fontFamily: "Plus Jakarta Sans",
          description: "Plus Jakarta Sans dipilih untuk menghadirkan nuansa bersih, modern, dan penuh energi. Bentuk hurufnya yang geometris namun dinamis sangat cocok dengan tema keaktifan, kebugaran, dan gaya hidup sehat masa kini."
        },
        colors: [
          { name: "Energy Orange", hex: "#FF6B00", type: "Primary Color", desc: "Warna orange membangkitkan vitalitas, antusiasme, semangat membara untuk bergerak, dan memicu tindakan aktif." },
          { name: "Premium Charcoal", hex: "#1E1E1E", type: "Dark Neutral", desc: "Digunakan sebagai warna utama teks dan latar belakang gelap untuk memberikan kesan premium, kokoh, dan modern." },
          { name: "Dynamic Neon Green", hex: "#CCFF00", type: "Accent Color", desc: "Memberikan aksen segar, futuristik, kontras tinggi yang menyorot tombol interaktif dan pencapaian penting." },
          { name: "Clean Health White", hex: "#FFFFFF", type: "Base Color", desc: "Menjamin keterbacaan tingkat tinggi serta memberi kesan bersih, lega, dan steril pada antarmuka." },
          { name: "Soft Surface Gray", hex: "#F8FAFC", type: "Neutral Light", desc: "Latar belakang lembut untuk kartu konten (cards) dan sekat pembagi informasi agar tata letak tidak membosankan." }
        ]
      },
      tools: ["Figma", "Adobe Illustrator", "Google Slides", "Miro"]
    }
  },
];

export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'website',
  },
  {
    name: 'ui/ux',
  },
  {
    name: 'branding',
  },
];
